import React from 'react';
import { Helmet } from 'react-helmet';
import { CssBaseline } from '@material-ui/core';
import { Box, makeStyles } from '@popmenu/common-ui';
import { Footer } from '../Footer';
import { Modals } from '../Modals';
import { Nav } from '../Nav';
import { PageChangeHandler } from '../PageChangeHandler';
import { PageContent } from '../PageContent';

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  inner: {
    minHeight: 'calc(100vh - 56px)',
  },
}));

export const Page = () => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Helmet
        defaultTitle="eat.popmenu.com"
        titleTemplate="%s - eat.popmenu.com"
      />
      <CssBaseline />
      <Box className={classes.container}>
        <Box className={classes.inner}>
          <Nav />
          <PageContent />
        </Box>
        <Footer />
      </Box>
      <Modals />
      <PageChangeHandler />
    </React.Fragment>
  );
};
